import type {
  Anchor,
  Point,
  Polygon,
  QuadraticBezierLinePart,
} from '../elements';
import type { Degrees } from '../utils/angles';

export const EDGE_CIRCLE_RADIUS = 6;

export interface EdgePositionsLabel {
  anchor: Anchor;
  angle: Degrees;
  position: Point;
}

/**
 * Line is composed of points. They create line together.
 * Every point can be different. Line can start as straight line, continue as bezier curve and finish as straight line.
 * Line does not necessarily need be composed of only straight lines or only of bezier curves.
 * Example: [Point, Point, QuadraticBezierLinePart, Point, QuadraticBezierLinePart, Point]
 */
export type EdgePositionsLine = [Point, ...(Point | QuadraticBezierLinePart)[]];

export function isEdgeLinePoint(
  element: Point | QuadraticBezierLinePart,
): element is Point {
  return Object.hasOwnProperty.call(element, 'x');
}

export function isEdgeLineQuadraticBezier(
  element: Point | QuadraticBezierLinePart,
): element is QuadraticBezierLinePart {
  return Object.hasOwnProperty.call(element, 'c');
}

export type EdgePositionsArrowHead = Polygon;

export interface EdgePositionsCircle {
  position: Point;
  radius: number;
}

export type EdgePositionsLabels = {
  source?: EdgePositionsLabel;
  center?: EdgePositionsLabel;
  target?: EdgePositionsLabel;
};

export interface EdgePositions {
  arrowHeads?: {
    source?: EdgePositionsArrowHead;
    target?: EdgePositionsArrowHead;
  };
  circle?: EdgePositionsCircle;
  labels?: EdgePositionsLabels;
  line: EdgePositionsLine;
}

export const getEdgeArrowHeadsList = (
  positions: EdgePositions,
): EdgePositionsArrowHead[] => {
  const result = [];
  if (positions.arrowHeads?.source) {
    result.push(positions.arrowHeads.source);
  }
  if (positions.arrowHeads?.target) {
    result.push(positions.arrowHeads.target);
  }
  return result;
};
